import type { ReactNode } from 'react';

export const symbol_b_circle: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M380-259h117q72 0 110.5-33t38.5-93q0-45-24-71.5T550-491v-2q39-8 60.5-33.5T632-592q0-57-38.5-83T471-701h-91q-13 0-21.5 8.5T350-671v382q0 13 8.5 21.5T380-259Zm20-251v-151h73q57 0 82.5 17.5T581-587q0 42-23 59.5T482-510h-82Zm0 211v-171h84q57 0 83 19.5t26 62.5q0 45-25.5 67T488-299h-88Zm-76 187.5Q251-143 197-197t-85.5-127Q80-397 80-480t31.5-156Q143-709 197-763t127-85.5Q397-880 480-880t156 31.5Q709-817 763-763t85.5 127Q880-563 880-480t-31.5 156Q817-251 763-197t-127 85.5Q563-80 480-80t-156-31.5Zm397-128Q820-339 820-480t-99.5-240.5Q621-820 480-820t-240.5 99Q140-622 140-480t99 241q99 99 241 99t241-99.5ZM480-480Z"
		/>
	</svg>
);
